import { post, get } from "../../../services/request";

// Service to fetch the list of tenants
export const fetchTenantManagementService = () => {
  return get("AdvanceScheduling/Tenant/GetAllTenants");
};

// Service to get tenant by ID
export const getTenantByIdService = (tenantId) => {
  return get(`AdvanceScheduling/Tenant/GetTenantDetails?tenantID=${tenantId}`);
};

// Service to save tenant details
export const saveTenantDetailsService = (tenantData) => {
  return post("AdvanceScheduling/Tenant/SaveTenantDetails", tenantData);
};

// Service to get all master tenant types for dropdown
export const getAllMasterTenantTypesService = () => {
  return get("AdvancedSchedulingCommon/GetAllMasterTenantsTypes_DD");
};

// Service to save tenant
export const saveTenantService = (tenantData) => {
  return post("AdvanceScheduling/Tenant/SaveTenantDetails", tenantData);
};

// Service to get storage category dropdown
export const getStorageCategoryDropdownService = () => {
  return get("AdvancedSchedulingCommon/GetAllStorageCategory_DD");
};

// Service to get all master country dropdowns
export const getAllMasterCountryService = () => {
  return get("AdvancedSchedulingCommon/GetAllMasterCountry_DropDowns");
};

// Service to get all master timezone dropdowns
export const getAllMasterTimeZoneService = () => {
  return get("MasterTimeZone/GetAll");
};

// Service to activate/deactivate tenant management
export const activateDeactivateTenantService = (tenantId, isActive) => {
  return post("AdvanceScheduling/Tenant/EnableDisableTenantDetails", {
    TenantId: tenantId,
    Status: isActive,
  });
};

// Service to soft delete tenant
export const deleteTenantService = (tenantId, modifiedBy) => {
  return post("AdvanceScheduling/Tenant/DeleteTenant", {
    TenantId: tenantId,
    ModifiedBy: modifiedBy,
  });
};

// Service to get default tenant configuration (from the selected tenant's DB)
export const getDefaultTenantConfigService = (tenantId) => {
  return get(`AdvanceScheduling/Tenant/GetDefaultTenantConfig?tenantId=${tenantId}`);
};

// Service to save default tenant configuration (to the selected tenant's DB)
export const saveDefaultTenantConfigService = (configData) => {
  return post("AdvanceScheduling/Tenant/SaveDefaultTenantConfig", configData);
};
